module.exports = __webpack_public_path__ + "img/maky-5.b2051915.png";